<div class="view-shortcuts">
  <div *ngFor="let group of shortcutGroups" class="view-shortcuts__group">
    <h2 class="view-shortcuts__label text-bold">{{ group.label }}</h2>
    <table class="view-shortcuts__table">
      <tr>
        <th></th>
        <th class="view-shortcuts__cell-header" scope="col">Keyboard Shortcut</th>
      </tr>
      <tr *ngFor="let shortcut of group.shortcuts">
        <th scope="row" class="view-shortcuts__cell-header">{{ shortcut.label }}</th>
        <td class="view-shortcuts__cell view-shortcuts__cell--key">
          <span *ngFor="let key of shortcut.keys">
            <kbd
              class="view-shortcuts__key"
              [attr.aria-hidden]="key.hasOwnProperty('pronunciation')">
              {{ key.shortcut }}
            </kbd>
            <label *ngIf="key.hasOwnProperty('pronunciation')" class="visually-hidden">{{
              key.pronunciation
            }}</label>
          </span>
        </td>
      </tr>
    </table>
  </div>
</div>
